
import React, { useEffect, useRef, useState } from "react";

const Team = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  /*
   * Replace these placeholders with the actual
   * founder information and photos.
   */
  const founders = [
    {
      id: "01",
      name: "Founder Name",
      role: "Co-Founder & Managing Partner",
      description:
        "Driving the company's strategic direction, client relationships, and long-term growth across the construction estimating industry.",
      image:"",
        // "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=900&q=90",
    },
    {
      id: "02",
      name: "Founder Name",
      role: "Co-Founder & Estimating Director",
      description:
        "Leading estimating operations, quantity takeoffs, project review, and quality-focused delivery across multiple construction divisions.",
      image:"",
        // "https://images.unsplash.com/photo-1566492031773-4f4e44671857?auto=format&fit=crop&w=900&q=90",
    },
    {
      id: "03",
      name: "Founder Name",
      role: "Co-Founder & Operations Director",
      description:
        "Building efficient project workflows and coordinating teams to deliver organized, dependable estimating support for clients.",
      image:"",
        // "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=90",
    },
  ];

  return (
    <>
      <style>{`

        /* =========================================
           TEAM SECTION
        ========================================= */

        .sg-team {
          position: relative;
          overflow: hidden;

          padding: 120px 0;

          background:
            linear-gradient(
              180deg,
              #f7faff 0%,
              #ffffff 48%,
              #f7faff 100%
            );
        }

        .sg-team-container {
          position: relative;
          z-index: 2;

          width: min(1380px, 92%);
          margin: auto;
        }

        /* =========================================
           BACKGROUND BLUEPRINT
        ========================================= */

        .sg-team-blueprint {
          position: absolute;

          width: 700px;
          height: 700px;

          left: -230px;
          top: 40px;

          opacity: 0.38;

          background-image:
            linear-gradient(
              rgba(24, 87, 173, 0.055) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(24, 87, 173, 0.055) 1px,
              transparent 1px
            );

          background-size: 35px 35px;

          transform: rotate(-8deg);

          pointer-events: none;
        }

        .sg-team-blueprint::before {
          content: "";

          position: absolute;

          width: 400px;
          height: 400px;

          left: 170px;
          top: 130px;

          border: 1px solid rgba(22, 88, 179, 0.09);

          border-radius: 50%;
        }

        .sg-team-blueprint::after {
          content: "";

          position: absolute;

          width: 300px;
          height: 300px;

          left: 220px;
          top: 180px;

          border: 1px dashed rgba(22, 88, 179, 0.09);

          border-radius: 50%;
        }

        /* =========================================
           HEADER
        ========================================= */

        .sg-team-heading {
          text-align: center;

          max-width: 760px;

          margin: 0 auto 65px;

          opacity: 0;
          transform: translateY(30px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease;
        }

        .sg-team-heading.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-team-label {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;

          color: #175bc3;

          font-size: 12px;
          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-team-label-line {
          width: 30px;
          height: 2px;

          border-radius: 10px;

          background: #f39818;
        }

        .sg-team-title {
          margin: 17px 0 18px;

          color: #10213f;

          font-size: clamp(39px, 4.2vw, 61px);

          line-height: 1.05;

          letter-spacing: -2.4px;

          font-weight: 800;
        }

        .sg-team-title span {
          color: #1b60c8;
        }

        .sg-team-intro {
          max-width: 650px;

          margin: auto;

          color: #68768a;

          font-size: 16px;

          line-height: 1.75;
        }

        /* =========================================
           FOUNDERS GRID
        ========================================= */

        .sg-founders {
          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 24px;

          align-items: stretch;
        }

        /* =========================================
           FOUNDER CARD
        ========================================= */

        .sg-founder-card {
          position: relative;

          min-height: 570px;

          overflow: hidden;

          border-radius: 21px;

          background: #ffffff;

          border: 1px solid #e1e9f3;

          box-shadow:
            0 15px 45px rgba(26, 59, 97, 0.08);

          opacity: 0;

          transform: translateY(45px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease,
            box-shadow 0.3s ease;
        }

        .sg-founder-card.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-founder-card:nth-child(2) {
          transition-delay: 0.12s;
        }

        .sg-founder-card:nth-child(3) {
          transition-delay: 0.24s;
        }

        .sg-founder-card:hover {
          transform: translateY(-8px);

          box-shadow:
            0 28px 65px rgba(25, 62, 105, 0.15);
        }

        /* =========================================
           IMAGE
        ========================================= */

        .sg-founder-image-wrapper {
          position: relative;

          height: 390px;

          overflow: hidden;

          background:
            linear-gradient(
              135deg,
              #eaf2fc,
              #dce8f7
            );
        }

        .sg-founder-image {
          width: 100%;
          height: 100%;

          display: block;

          object-fit: cover;

          object-position: center;

          filter: saturate(0.92);

          transition:
            transform 0.55s ease,
            filter 0.55s ease;
        }

        .sg-founder-card:hover
        .sg-founder-image {
          transform: scale(1.055);

          filter: saturate(1);
        }

        /* Image overlay */

        .sg-founder-image-wrapper::after {
          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              180deg,
              rgba(16, 38, 70, 0) 45%,
              rgba(16, 38, 70, 0.54) 100%
            );

          pointer-events: none;
        }

        /* Founder number */

        .sg-founder-number {
          position: absolute;

          z-index: 4;

          top: 18px;
          left: 18px;

          display: flex;

          align-items: center;
          justify-content: center;

          width: 44px;
          height: 44px;

          border-radius: 11px;

          background: rgba(255,255,255,0.93);

          color: #1558c0;

          font-size: 13px;

          font-weight: 900;

          box-shadow:
            0 8px 20px rgba(16, 45, 78, 0.12);

          backdrop-filter: blur(10px);
        }

        /* =========================================
           IMAGE ROLE LABEL
        ========================================= */

        .sg-founder-role-image {
          position: absolute;

          z-index: 4;

          left: 22px;
          bottom: 21px;

          color: white;

          font-size: 11px;

          font-weight: 800;

          letter-spacing: 1px;

          text-transform: uppercase;
        }

        /* =========================================
           CARD CONTENT
        ========================================= */

        .sg-founder-content {
          padding: 25px 25px 27px;
        }

        .sg-founder-name {
          margin: 0;

          color: #10213f;

          font-size: 24px;

          line-height: 1.2;

          font-weight: 800;

          letter-spacing: -0.5px;
        }

        .sg-founder-role {
          margin-top: 7px;

          color: #1558c0;

          font-size: 11px;

          line-height: 1.4;

          font-weight: 800;

          letter-spacing: 0.5px;

          text-transform: uppercase;
        }

        .sg-founder-description {
          margin: 14px 0 0;

          color: #738095;

          font-size: 12px;

          line-height: 1.7;
        }

        /* =========================================
           LINK / CONNECT
        ========================================= */

        .sg-founder-footer {
          display: flex;

          align-items: center;
          justify-content: space-between;

          margin-top: 21px;

          padding-top: 16px;

          border-top: 1px solid #e8edf3;
        }

        .sg-founder-focus {
          color: #8994a4;

          font-size: 9px;

          font-weight: 700;

          letter-spacing: 0.8px;

          text-transform: uppercase;
        }

        .sg-founder-arrow {
          width: 34px;
          height: 34px;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 50%;

          background: #edf4ff;

          color: #1558c0;

          font-size: 15px;

          transition:
            background 0.25s ease,
            color 0.25s ease,
            transform 0.25s ease;
        }

        .sg-founder-card:hover
        .sg-founder-arrow {
          color: white;

          background: #1558c0;

          transform: translateX(3px);
        }

        /* =========================================
           TEAM VALUES
        ========================================= */

        .sg-team-values {
          display: grid;

          grid-template-columns:
            repeat(3, 1fr);

          gap: 20px;

          margin-top: 65px;

          padding-top: 35px;

          border-top: 1px solid #e1e8f1;
        }

        .sg-team-value {
          display: flex;

          align-items: center;

          gap: 14px;

          padding: 5px 15px;
        }

        .sg-team-value-icon {
          width: 45px;
          height: 45px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 12px;

          background: #edf4ff;

          color: #1558c0;

          font-size: 18px;
        }

        .sg-team-value strong {
          display: block;

          color: #172945;

          font-size: 13px;
        }

        .sg-team-value span {
          display: block;

          margin-top: 4px;

          color: #8792a2;

          font-size: 10px;
        }

        /* =========================================
           DECORATIVE ORANGE DOT
        ========================================= */

        .sg-team-dot {
          position: absolute;

          right: 8%;
          top: 95px;

          width: 9px;
          height: 9px;

          border-radius: 50%;

          background: #f39818;

          box-shadow:
            0 0 0 8px rgba(243,152,24,0.09);
        }

        /* =========================================
           TABLET
        ========================================= */

        @media (max-width: 1000px) {

          .sg-team {
            padding: 90px 0;
          }

          .sg-founders {
            gap: 16px;
          }

          .sg-founder-card {
            min-height: 520px;
          }

          .sg-founder-image-wrapper {
            height: 330px;
          }

          .sg-founder-content {
            padding: 21px;
          }

          .sg-founder-name {
            font-size: 20px;
          }

          .sg-team-values {
            gap: 10px;
          }
        }

        /* =========================================
           MOBILE
        ========================================= */

        @media (max-width: 760px) {

          .sg-team {
            padding: 80px 0;
          }

          .sg-team-heading {
            margin-bottom: 45px;
          }

          .sg-team-title {
            font-size: 39px;

            letter-spacing: -1.7px;
          }

          .sg-team-intro {
            font-size: 15px;
          }

          .sg-founders {
            grid-template-columns: 1fr;

            max-width: 540px;

            margin: auto;

            gap: 22px;
          }

          .sg-founder-card {
            min-height: auto;
          }

          .sg-founder-image-wrapper {
            height: 390px;
          }

          .sg-team-values {
            grid-template-columns: 1fr;

            gap: 12px;

            margin-top: 50px;
          }

          .sg-team-value {
            padding: 8px 0;
          }

          .sg-team-dot {
            display: none;
          }
        }

        /* =========================================
           SMALL MOBILE
        ========================================= */

        @media (max-width: 480px) {

          .sg-team {
            padding: 65px 0;
          }

          .sg-team-title {
            font-size: 35px;
          }

          .sg-founder-image-wrapper {
            height: 350px;
          }

          .sg-founder-content {
            padding: 21px;
          }

          .sg-founder-name {
            font-size: 21px;
          }

        }

      `}</style>

      <section
        className="sg-team"
        id="team"
        ref={sectionRef}
      >

        <div className="sg-team-blueprint"></div>

        <div className="sg-team-dot"></div>

        <div className="sg-team-container">

          {/* =====================================
              SECTION HEADER
          ===================================== */}

          <div
            className={`sg-team-heading ${
              visible ? "visible" : ""
            }`}
          >

            <div className="sg-team-label">

              <span className="sg-team-label-line"></span>

              Meet Our Founders

              <span className="sg-team-label-line"></span>

            </div>

            <h2 className="sg-team-title">
              Built on Experience.
              <br />
              Driven by <span>Precision.</span>
            </h2>

            <p className="sg-team-intro">
              Our founding team brings together construction
              estimating, project operations, and business
              expertise to build a reliable estimating partner
              for contractors and construction professionals.
            </p>

          </div>


          {/* =====================================
              FOUNDERS
          ===================================== */}

          <div className="sg-founders">

            {founders.map((founder) => (

              <article
                className={`sg-founder-card ${
                  visible ? "visible" : ""
                }`}
                key={founder.id}
              >

                {/* IMAGE */}

                <div className="sg-founder-image-wrapper">

                  <img
                    className="sg-founder-image"
                    src={founder.image}
                    alt={`${founder.name} - ${founder.role}`}
                  />

                  <div className="sg-founder-number">
                    {founder.id}
                  </div>

                  <div className="sg-founder-role-image">
                    {founder.role}
                  </div>

                </div>


                {/* CONTENT */}

                <div className="sg-founder-content">

                  <h3 className="sg-founder-name">
                    {founder.name}
                  </h3>

                  <div className="sg-founder-role">
                    {founder.role}
                  </div>

                  <p className="sg-founder-description">
                    {founder.description}
                  </p>


                  <div className="sg-founder-footer">

                    <span className="sg-founder-focus">
                      StructGuard Leadership
                    </span>

                    <span className="sg-founder-arrow">
                      →
                    </span>

                  </div>

                </div>

              </article>

            ))}

          </div>


          {/* =====================================
              TEAM VALUES
          ===================================== */}

          <div className="sg-team-values">

            <div className="sg-team-value">

              <div className="sg-team-value-icon">
                ◈
              </div>

              <div>
                <strong>
                  Construction Expertise
                </strong>

                <span>
                  Understanding project scope & costs
                </span>
              </div>

            </div>


            <div className="sg-team-value">

              <div className="sg-team-value-icon">
                ✓
              </div>

              <div>
                <strong>
                  Quality Focused
                </strong>

                <span>
                  Structured review before delivery
                </span>
              </div>

            </div>


            <div className="sg-team-value">

              <div className="sg-team-value-icon">
                ↗
              </div>

              <div>
                <strong>
                  Client Driven
                </strong>

                <span>
                  Built around contractor requirements
                </span>
              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default Team;



// ### Replace the 3 founders

// At the top of `Team.js`, you'll see:

// ```jsx
// const founders = [
//   {
//     id: "01",
//     name: "Founder Name",
//     role: "Co-Founder & Managing Partner",
//     ...
//   },
//   ...
// ];
// ```

// Replace:

// ```jsx
// name: "Founder Name"
// ```

// with the actual founder names, and replace the `image` URLs with their professional photos.

// For example:

// ```jsx
// {
//   id: "01",
//   name: "John Smith",
//   role: "Co-Founder & Managing Partner",
//   description:
//     "Leading StructGuard's strategic direction and client relationships.",
//   image: "/images/founders/john-smith.jpg",
// }
// ```

// // Then place the photos in:

// ```text
// public/
// └── images/
//     └── founders/
//         ├── john-smith.jpg
//         ├── founder-two.jpg
//         └── founder-three.jpg
// ```

// This is preferable for the final website because **founder photos should be your actual professional photographs**, not stock photos.

// The section is already responsive: **3 cards on desktop → 1 card per row on mobile**, with staggered entrance animation and image zoom on hover.
